export default __webpack_public_path__ + "static/media/books-768w.abf07aa5.png";